<div class="checkboxGroup" [formGroup]="field.control" [transform]="toDbModel.bind(this)">
  <h3>{{ field.key | translate }}</h3>
  <div class="checkboxes">
    <ng-container *ngFor="let item of selectItems$ | async">
      <mat-checkbox formControlName={{item.id}}>
        {{ item.text | translate }}
      </mat-checkbox>
    </ng-container>
  </div>
</div>
